<div class="ktc-toast-container" aria-live="polite" aria-atomic="true">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="ktc-toast ktc-toast--{{ toast.type }}" role="alert" aria-live="assertive" aria-atomic="true" (click)="toastService.remove(toast.id)">
      <div class="ktc-toast__title">{{ toast.title }}</div>
      <div class="ktc-toast__message">{{ toast.message }}</div>
    </div>
  }
</div>
